/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { Guidelines } from './components/Guidelines';
import { ScrollProgress } from './components/ScrollProgress';
import { Menu } from './components/Menu';
import { MenuFixed } from './components/MenuFixed';
import { Cursor } from './components/Cursor';
import { Loader } from './components/Loader';
import { throttle } from './utils/proto/throttle';
import configData from './config/data';
import Routes from './routes';

const propTypes = {
	name: PropTypes.string,
	mobile: PropTypes.bool,
	data: PropTypes.object,
};

const defaultProps = {
	name: '',
	mobile: false,
	data: configData,
};

export const App = ({
	name,
	version,
	mobile,
	cluster,
	data: info,
	...props
}) => {
	const [isLoading, setIsLoading] = React.useState(true);
	const [assets, setAssets] = React.useState(null);
	const progress = React.useRef(0);

	const onLoadStart = (() => {
		document.body.classList.remove('is-rendering');
		document.body.classList.add('is-loading');
	});

	const onLoadProgress = ((file, percentage) => {
		progress.current = percentage;
	});

	const onLoadComplete = ((response) => {
		document.body.classList.remove('is-loading');
		setAssets(response);
	});

	const onLoadTransitionOutComplete = (() => {
		setIsLoading(false);
	});

	const renderLoader = () => isLoading && (
		<Loader
			visible={isLoading}
			assets={info.loader.data[mobile ? 'mobile' : 'desktop']}
			onStart={onLoadStart}
			onProgress={onLoadProgress}
			onComplete={onLoadComplete}
			onTransitionOutComplete={onLoadTransitionOutComplete}
		/>
	);

	const fixViewportHeight = throttle(() => {
		const vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--vh', `${vh}px`);
	}, 33, { leading: true });

	React.useEffect(() => {
		fixViewportHeight();
		window.addEventListener('resize', fixViewportHeight, false);
		return () => window.removeEventListener('resize', fixViewportHeight, false);
	}, []);

	React.useLayoutEffect(() => {
		console.log('v%s', version);
		DataLayer.init(info.tracks.data, cluster.slug, mobile ? 'm' : 'd');
		return () => window.removeEventListener('resize', fixViewportHeight, false);
	}, []);
	console.log(info);

	return (
		<React.Fragment>
			<div data-ui-app={true}>
				<ScrollProgress color={'#e50353'} height={2} />
				<Routes name={name} version={version} mobile={mobile} data={info} cluster={cluster} />
				<Menu name={name} version={version} mobile={mobile} />
				{mobile && <MenuFixed/>}
			</div>
			{renderLoader()}
			{!mobile && <Cursor/>}
			<Guidelines columns={(mobile ? 12 : 16)} rows={0} />
		</React.Fragment>
	);
};

App.displayName = 'App';
App.propTypes = propTypes;
App.defaultProps = defaultProps;
export default React.memo(App);
